module.exports = __webpack_public_path__ + "img/a1ae18e0e6acd19a305572cfa2b01b7b.svg";